import { z } from "zod";

/** ポータル全体の設定(SPEC §2.4)。いまは全体の管理者の一覧だけ。 */
export const portalSettingsViewSchema = z.object({
  systemAdminEmails: z.array(z.email()),
  updatedAt: z.iso.datetime(),
  updatedBy: z.email().nullable(),
  revision: z.number().int().positive(),
});
export type PortalSettingsView = z.infer<typeof portalSettingsViewSchema>;

/** まだ初期投入していなければ settings は null。 */
export const portalSettingsResponseSchema = z.object({
  settings: portalSettingsViewSchema.nullable(),
});
export type PortalSettingsResponse = z.infer<typeof portalSettingsResponseSchema>;

export const updateSystemAdminsRequestSchema = z.object({
  // 空配列は受け付けない。管理者がいなくなると管理画面から戻せなくなる
  systemAdminEmails: z.array(z.email()).min(1),
  revision: z.number().int().positive(),
});
export type UpdateSystemAdminsRequest = z.infer<typeof updateSystemAdminsRequestSchema>;
